import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import { ColorBox } from 'styles/components/Color';

const Color = ({ title, onClick, code, selected }) => (
  <Tooltip
    TransitionComponent={Zoom}
    TransitionProps={{ timeout: 200 }}
    title={title}
    arrow>
    <ColorBox
      selected={selected}
      code={code}
      onClick={() => _.isFunction(onClick) && onClick()}
    />
  </Tooltip>
);

Color.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  code: PropTypes.string,
  selected: PropTypes.bool,
};

export default Color;
